import React from 'react';

import Modal from './Modal';
import Button from '../FormElements/Button';

const ErrorModal = (props) => {
  return (
    <Modal
      onCancel={props.onClear}
      header={props.header || (props.children ? 'Prescription review' : 'Something went wrong')}
      show={!!(props.children || props.error)}
      footer={<Button onClick={props.onClear}>Okay</Button>}
    >
      {props.children || <p role="alert">{props.error}</p>}
    </Modal>
  );
};

export default ErrorModal;
